<template>
  <v-form>
    <validation-observer ref="observer" v-slot="{invalid, reset, handleSubmit}">
      <v-card>
        <v-card-title>{{model.id ? 'Изменить карточку транспорта' : 'Создать карточку транспорта'}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{errors}" name="number" rules="required|max:12">
                <v-text-field v-model="model.number"
                              required :error-messages="errors"
                              label="Гос номер"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider v-slot="{errors}" name="model" rules="max:100">
                <v-text-field v-model="model.model"
                              required :error-messages="errors"
                              label="Модель"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <v-autocomplete v-model="model.driver_staff"
                              :items="driverOptions" :loading="loadingStaff"
                              item-value="id" item-text="name"
                              label="Водитель" prepend-inner-icon="mdi-account-tie"
                              clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-space-between pb-4 px-4">
          <v-btn @click="handleSubmit(save)"
                 :loading="!!saving"
                 :disabled="!!saving || invalid"
                 rounded color="success"
          ><v-icon left>mdi-content-save</v-icon> {{model.id ? 'Сохранить' : 'Создать'}}</v-btn>
          <v-btn @click="cancel(reset)"
                 :disabled="!!saving"
                 :loading="!!saving"
                 rounded text color="error"
          ><v-icon left>mdi-cancel</v-icon> Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-form>
</template>

<script>
  import {mapState} from 'vuex'
  import {filters} from '@/filters'

  export default {
    name: 'transport-form',

    data() {
      return {
        staff: [],
        loadingStaff: false,
      }
    },

    computed: {
      ...mapState('Transport', ['saving', 'model']),

      driverOptions() {
        const options = this.staff.map(s => ({id: s.id, name: filters.full_name(s).replace(/s+/g, ' ').trim()}))
        // Keep the current driver selectable even if they are no longer active
        if (this.model.driver_staff && !options.some(o => o.id === this.model.driver_staff)) {
          options.unshift({id: this.model.driver_staff, name: this.model.driver_name || `#${this.model.driver_staff}`})
        }
        return options
      },
    },

    created() {
      this.loadingStaff = true
      this.$store.dispatch('Staff/fetchOptions')
        .then(staff => this.staff = staff)
        .finally(() => this.loadingStaff = false)
    },

    methods: {
      cancel(reset) {
        reset()
        this.$emit('transport:form:cancel')
      },

      save() {
        this.$store
          .dispatch('Transport/save')
          .then(() => {
            this.$emit('transport:form:saved')
          })
      },
    },
  }
</script>
